<template>
  <div :class="[isEdit ?  'page-main-tab-bar':'page-main' ]">
    <div class="nav-bar">
      <van-nav-bar
        fixed
        :z-index="999"
        left-text="返回"
        :right-text="ritghText"
        left-arrow
        @click-left="goBack"
        @click-right="onClickRight"
      />              
    </div> 
    <div class="content">
      <van-tabs v-model="active" @click="handleTabs">
        <van-tab title="收藏">
          <Collect ref="collect" @getCheckIds="getCheckIds" @onSuccess="init"></Collect>
        </van-tab>
        <van-tab title="评论">
          <Comment ref="comment"></Comment>
        </van-tab>
        <van-tab title="有用">
          <Have ref="have" @getCheckIds="getCheckIds" @onSuccess="init"></Have>
        </van-tab>
      </van-tabs>       
    </div>         
 
    <transition name="van-slide-up">
      <div v-show="isEdit" class="footer-btn">
        <van-button class="btn" block square @click="init">取消</van-button>
        <van-button class="btn" type="primary" :disabled="disabled" :loading="loading" loading-text="保存中..." block square @click="submit">删除</van-button>
      </div>
    </transition> 
  </div>
</template>

<script>
import Collect from './collect'
import Comment from './comment'
import Have from './have'
import commonMix from "@/mixins/commonMix"
export default {
  name: 'behaviour',
  components: { Collect, Comment, Have },
  mixins: [commonMix],
  data() {
    return {
      currRef: 'collect',
      active: 0,
      isEdit: false,
      disabled: false,
      loading: false,
      Ids: []
    }
  },
  computed: {
    ritghText() {
      if (this.$route.params.title === 'comment') return ''
      return this.isEdit ? '取消' : '编辑'
    }
  },
  // created() {
  //   this.handleNav(this.$route.params.title)
  //   this.currRef = this.$route.params.title
  // },
  activated() {
    this.handleNav(this.$route.params.title)
    this.currRef = this.$route.params.title
  },
  methods: {
    init() {
      this.isEdit = false
      this.disabled = false
      this.loading = false
      this.$nextTick(() => {
        this.$refs[this.currRef].isEdit = this.isEdit
      })
    },
    handleNav(title) {
      switch (title) {
        case 'collect':
          this.active = 0
          break;
        case 'comment':
          this.active = 1

          break;
        case 'have':
          this.active = 2
          break;

        default:
          break;
      }
    },
    onClickRight() {
      this.$nextTick(() => {
        let comp = this.$refs[this.currRef]
        if (comp.list && comp.list.length) {
          this.isEdit = !this.isEdit
          comp.isEdit = this.isEdit
        }
      })
    },
    handleTabs(i) {
      switch (i) {
        case 0:
          this.$router.replace({ name: 'behaviour', params: { title: 'collect' } })
          this.currRef = 'collect'
          this.$nextTick(() => {
            this.isEdit = this.$refs[this.currRef].isEdit
            this.disabled = !this.$refs[this.currRef].Ids.length
          })
          break;
        case 1:
          this.$router.replace({ name: 'behaviour', params: { title: 'comment' } })
          this.currRef = 'comment'
          this.isEdit = false
          break;
        case 2:
          this.$router.replace({ name: 'behaviour', params: { title: 'have' } })
          this.currRef = 'have'
          this.$nextTick(() => {
            this.isEdit = this.$refs[this.currRef].isEdit
            this.disabled = !this.$refs[this.currRef].Ids.length
          })
          break;

        default:
          break;
      }
    },
    getCheckIds(Ids) {
      this.disabled = !Ids.length
    },
    submit() {
      this.$nextTick(() => {
        this.loading = true
        this.disabled = true
        this.$refs[this.currRef].submit()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  min-height: 46px;
}

.content {
  position: fixed;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 0;
  z-index: 1;
}

.footer-btn {
  display: flex;
  position: fixed;
  width: 100%;
  bottom: 0;
  text-align: center;
  background: #fff;
  z-index: 9999;
  .btn {
    flex: 1;
  }
}
.page-main-tab-bar {
  z-index: 999;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
